import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Subheader, CircularProgress, Paper } from 'material-ui';
import { isEmpty, map } from 'lodash';

import { fetch, createNewAccount } from 'actions/EmployeeBank';
import PanelMessage from 'components/panels/PanelMessage';
import EmployeeBankAccount from './EmployeeBankAccount';
import styles from './styles/Cards';

/** Wrapper Component for EmployeeBankAccount */
const EmployeeBank = ({
  loaded,
  branchesLoaded,
  error,
  hasError,
  accounts,
  dispatch,
}) => {
  useEffect(() => {
    dispatch(fetch());
  }, []);

  const renderAccounts = () => {
    if (!loaded || !branchesLoaded) return <Paper style={styles.loading}><CircularProgress /></Paper>;

    if (hasError) {
      return (
        <PanelMessage
          zDepth={1}
          type="error"
          iconName="error"
          message={error.Message || <FormattedMessage id="bank.error" />}
        />);
    }

    if (isEmpty(accounts)) {
      return (<PanelMessage
        message={<FormattedMessage id="bank.none" />}
        iconName="info"
        type="info"
        action={() => dispatch(createNewAccount())}
        actionLabel={<FormattedMessage id="bank.add" />}
      />);
    }

    return map(accounts, (a, i) => <EmployeeBankAccount key={i} account={a} />);
  };

  return (
    <React.Fragment>
      <Subheader style={styles.subheader}><FormattedMessage id="bank.title" /></Subheader>
      {renderAccounts()}
    </React.Fragment>
  );
};

EmployeeBank.propTypes = {
  loaded: PropTypes.bool.isRequired,
  branchesLoaded: PropTypes.bool.isRequired,
  error: PropTypes.object,
  hasError: PropTypes.bool.isRequired,
  accounts: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
};

EmployeeBank.defaultProps = {
  error: null,
  accounts: {},
};

const mapStateToProps = ({ EmployeeBankReducer }) => ({ ...EmployeeBankReducer });

export default connect(mapStateToProps)(EmployeeBank);



// WEBPACK FOOTER //
// ./src/containers/pay/EmployeeBank.js